import * as React from 'react';
import { useDispatch } from 'react-redux';
import { RoundButton } from '@cian/ui-kit';
import { IconToggleHeartOn16, IconToggleHeartOff16 } from '@cian/ui-kit-design-tokens/icons';
import { debounce } from 'throttle-debounce';

import { TThunkDispatch } from '../../types/redux/thunk';
import { addNewbuildingFavorite, deleteNewbuildingFavorite } from '../../actions/newbuildingFavorite';
import { FAVORITE_DEBOUNCE_DELAY } from '../../constants/delays';

import * as style from './NewbuildingFavoriteButton.css';

export interface INewbuildingFavoriteButtonProps {
  newbuildingId: number;
  isFavorite: boolean;
  gaLabel?: string;
}

export const NewbuildingFavoriteButton: React.FC<INewbuildingFavoriteButtonProps> = ({
  newbuildingId,
  isFavorite,
  gaLabel = '',
}) => {
  const dispatch = useDispatch<TThunkDispatch>();

  const handleClick = React.useCallback(
    debounce(FAVORITE_DEBOUNCE_DELAY, () => {
      if (isFavorite) {
        dispatch(deleteNewbuildingFavorite({ newbuildingId, label: gaLabel }));
      } else {
        dispatch(addNewbuildingFavorite({ newbuildingId, label: gaLabel }));
      }
    }),
    [dispatch, newbuildingId, isFavorite, gaLabel],
  );

  return (
    <RoundButton
      data-testid="newbuilding-favorite-button"
      icon={
        isFavorite ? (
          // RoundButton перебивает цвет иконки своим темовым цветом; обёртка в div не даёт ему достучаться до svg (хак).
          <div className={style['icon']}>
            <IconToggleHeartOn16 color="control-negative-primary-default" />
          </div>
        ) : (
          <IconToggleHeartOff16 />
        )
      }
      onClick={handleClick}
      size="M"
      theme="light"
      title="В избранное"
    />
  );
};
